import { isComponentFor } from 'Shared/resolve-component';
export const isCategoryPageType = (currentPage) => {
    return isComponentFor(currentPage.componentName, "Avensia.Shop.Features.Category.Commerce.CategoryViewModel");
};
export default (state) => {
    return componentIsCategory(state.currentPage.componentName);
};
export function componentIsCategory(componentName) {
    return isComponentFor(componentName, "Avensia.Shop.Features.Category.Commerce.CategoryViewModel");
}
